// Which entries the map Options dialog shows, in order. Each map opts in through
// MapOptionsDialog's show* props; PRO+ tools come back separately so the dialog can group them.

export type MapOptionEvent =
  | 'edit-details' | 'edit' | 'create' | 'waypoints' | 'goto' | 'flyover'
  | 'download' | 'embed' | 'report-issue' | 'measurement' | 'print';

export interface MapOptionsVisibility {
  showEditDetails: boolean;
  editHike: boolean;
  showCreate: boolean;
  showWaypoints: boolean;
  showGoTo: boolean;
  showFlyover: boolean;
  showDownload: boolean;
  showEmbed: boolean;
  showReportIssue: boolean;
  showMeasurement: boolean;
  showPrint: boolean;
}

export interface MapOptionItem {
  event: MapOptionEvent;
  /** i18n key for the label. */
  labelKey: string;
  /** Material icon name. */
  icon: string;
}

const STANDARD: Array<MapOptionItem & { show: keyof MapOptionsVisibility }> = [
  { show: 'showEditDetails', event: 'edit-details', labelKey: 'shared.edit_details', icon: 'edit' },
  { show: 'editHike', event: 'edit', labelKey: 'map_options_dialog.open_route_in_planner', icon: 'edit_location' },
  { show: 'showCreate', event: 'create', labelKey: 'map_options_dialog.plan_a_hike', icon: 'add_location' },
  { show: 'showWaypoints', event: 'waypoints', labelKey: 'map_options_dialog.waypoints', icon: 'add_location_alt' },
  { show: 'showGoTo', event: 'goto', labelKey: 'map_options_dialog.go_to_location', icon: 'my_location' },
  { show: 'showFlyover', event: 'flyover', labelKey: 'shared.3d_flyover', icon: 'play_arrow' },
  { show: 'showDownload', event: 'download', labelKey: 'shared.download', icon: 'file_download' },
  { show: 'showEmbed', event: 'embed', labelKey: 'embed_builder.modal.embed_map', icon: 'code' },
  { show: 'showReportIssue', event: 'report-issue', labelKey: 'map_options_dialog.report_an_issue', icon: 'flag' },
];

const PRO: Array<MapOptionItem & { show: keyof MapOptionsVisibility }> = [
  { show: 'showMeasurement', event: 'measurement', labelKey: 'map_options_dialog.measurement_tool', icon: 'straighten' },
  { show: 'showPrint', event: 'print', labelKey: 'map_options_dialog.print_hike_map', icon: 'print' },
];

const pick = (items: typeof STANDARD, visibility: MapOptionsVisibility): MapOptionItem[] =>
  items.filter((item) => visibility[item.show]).map(({ event, labelKey, icon }) => ({ event, labelKey, icon }));

export function mapOptionsItems(visibility: MapOptionsVisibility): { standard: MapOptionItem[]; pro: MapOptionItem[] } {
  return { standard: pick(STANDARD, visibility), pro: pick(PRO, visibility) };
}
